import { render, staticRenderFns } from "./ReminderPanel.vue?vue&type=template&id=273fc022&scoped=true"
import script from "./ReminderPanel.vue?vue&type=script&lang=js"
export * from "./ReminderPanel.vue?vue&type=script&lang=js"
import style0 from "./ReminderPanel.vue?vue&type=style&index=0&id=273fc022&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273fc022",
  null
  
)

export default component.exports